import { getContext } from '@fiverr-private/fiverr_context';
import { QUALAS_USER_PAGE_LOYALTY_BANNER } from '../../../../experiments/experimentsEnum';
import { getVariation } from '../../../../experiments';

export const loyaltyPopoverOpenParams = ({ sellerId, sellerName }) => ({
    'Seller Id': sellerId,
    'Seller Name': sellerName
});

// This is a temp file that will be migrated, once the WithImpressions will utilze the Impressionable package.
export const loyaltyBigQueryParams = ({ sellerId, sellerName }) => {
    const { pageCtxId, userGuid, userId, isMobile, abTests = {} } = getContext();
    const platform = isMobile ? 'mobile_web' : 'web';
    const variation = getVariation(QUALAS_USER_PAGE_LOYALTY_BANNER, abTests);

    return {
        type: 'returning_buyers_banner',
        sub_group: 'content_impression',
        group: 'user_impressions',
        action: { type: 'impression' },
        domain: { name: 'quality' },
        publisher: {
            domain: 'algos',
            sub_domain: 'quality'
        },
        feature: {
            name: 'loyalty_program'
        },
        page: {
            name: 'user_page',
            ctx_id: pageCtxId,
            element: {
                name: 'loyalty_banner',
                type: 'text',
                text: 'buyers keep returning'
            }
        },
        out_of_session: false,
        platform,
        uid: userGuid,
        user: { id: userId },
        seller: { id: sellerId, username: sellerName },
        ab_test: [{
            experiment: QUALAS_USER_PAGE_LOYALTY_BANNER,
            group: variation
        }]
    };
};
